exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".typing-blinker::after {\n  content: \"|\";\n  opacity: 1;\n  -webkit-animation: blink 600ms steps(30, end) infinite;\n          animation: blink 600ms steps(30, end) infinite;\n}\n@-webkit-keyframes blink {\nto {\n    opacity: 0;\n}\n}\n@keyframes blink {\nto {\n    opacity: 0;\n}\n}\n", ""]);

// exports
